export class ConversionError extends Error {
    constructor(msg, type) {
        super(msg);
        this.type = type;
        this.message = msg;
        this.name = 'ConversionError';
    }
}
export const isConversionError = (err) => {
    return err instanceof Error && 'type' in err && err.name === 'ConversionError';
};
